import { getApi, postApi, putApi, deleteApi } from './apiBase';
import { feature_flags_get, feature_flags_evaluate, feature_flags_rules_get, feature_flags_rule_add, feature_flags_rule_update, feature_flags_rule_delete } from './apiURL';

export const getDefinedFlags = () => {
    return getApi(feature_flags_get);
};

export const evaluateFlags = () => {
    return getApi(feature_flags_evaluate);
};

export const getRulesForFlag = (flagKey) => {
    return getApi(`${feature_flags_rules_get}/${flagKey}/rules`);
};

export const createRule = (rule) => {
    return postApi(feature_flags_rule_add, rule);
};

export const updateRule = (ruleId, rule) => {
    return putApi(`${feature_flags_rule_update}/${ruleId}`, rule);
};

export const deleteRule = (ruleId) => {
    return deleteApi(`${feature_flags_rule_delete}/${ruleId}`);
};
